<template>
  <div class="h-100 d-flex flex-column">
    <div class="container text-center">
      <div class="row pt-4 pb-3">
        <div class="col-sm text-left">
          <h2>Купить лучший VPN — получите все возможности платной версии</h2>
          <p>Максимальная скорость соединения</p>
          <p>Более 60 локаций, 1260 серверов</p>
          <p>Поддержка торрентов, протокола P2P</p>
          <p>Оптимизировано для Netflix, Youtube, Disney+ и др.</p>
          <p>Отсутствие рекламы</p>
          <p>Специальные cерверы Double VPN, Onion-over-VPN</p>
          <p>Игровые cерверы с низким ping</p>
          <p>Конфигурации для роутеров и сторонних VPN приложений</p>
          <p>Поддержка 24/7 онлайн чат</p>
          <p>Бесконечное число сайтов для Smart фильтров в расширении браузеров</p>
          <button type="button" @click="$router.push('/buy-code')" class="btn btn-light btn-own mt-2 align-self-center ">
            Купить
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ContactUs'
}
</script>
